/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
    Autocomplete,
    Box,
    FormControl,
    Grid,
    IconButton,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';
import { debounce } from 'lodash';

// @context
import { payrollContext } from '../../payrollView';
import { useUI } from '../../../../app/context/ui';

// @assets
import { DialogFilterPayroll } from '../../../../assets/css/payroll-style';

// @helpers
import AppHelper from '../../../../helpers/AppHelper';

// @services
import CompanyServiceNewApi from '../../../../services/newApi/CompanyServiceNewApi';

// @components
import { ClearAllIcon, SearchRoundedIcon } from '../../../../components/shared/MaterialUI';
import { useSelector } from 'react-redux';

const FilterCompany = () => {
    const style = useMemo(() => DialogFilterPayroll(), []);
    const { blockUI, snackbarUI } = useUI();
    const companySNewApi = useMemo(() => new CompanyServiceNewApi(), []);
    const { setFilterModal, currentTab } = useContext(payrollContext);
    const [employeeName, setEmployeeName] = useState('');
    const [valueCompany, setValueCompany] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [listCompanies, setListCompanies] = useState([]);
    const orgSelected = useSelector(state => state.organizationReducer.organizationSelected);

    // Fetch company suggestions for autocomplete
    const handleChangeEmployer = debounce((query) => {
        const org = orgSelected?.id;
        if (!org) return;
        if (query?.length > 1) getAllCompanies({ name: query });
        if (!query) getAllCompanies();
    }, 500);

    const getAllCompanies = async (filters = {}) => {
        const sort = { order: true, direction: 'asc' };
        const organization = orgSelected?.id;
        try {
          blockUI.current.open(true);
          const response = await companySNewApi.getCompanies({ page: 1, size: 10 }, organization, filters, sort);
          setListCompanies(response?.data?.data || []);
          blockUI.current.open(false);
        } catch (error) {
          blockUI.current.open(false);
          AppHelper.checkError(error, snackbarUI);
        }
    }

    // When user selects from autocomplete dropdown
    const handleSelectEmployer = (event, newValue) => {
      setValueCompany(newValue || '');
    };

    // Search - apply filters
    const handleSearch = (e) => {
      if (e) e.preventDefault();
      const DATA = {};
      // Use valueCompany if selected, otherwise use inputValue (typed text)
      const employer = valueCompany || inputValue;
      if (employer) DATA.Employeer = employer;
      if (employeeName) DATA.EmployeeName = employeeName;
      setFilterModal(DATA);
    };

    // Clear all filters
    const handleClearFilters = () => {
      setValueCompany('');
      setInputValue('');
      setEmployeeName('');
      setFilterModal({});
    };

    // Reset on org change
    useEffect(() => {
      if (orgSelected?.id) {
        setListCompanies([]);
        handleClearFilters();
      }
    }, [orgSelected?.id]);

    // Reset on tab change
    useEffect(() => {
      if (currentTab) {
        handleClearFilters();
      }
    }, [currentTab]);

  return (
    <Grid sx={style.containerFilterCompany}>
        <form onSubmit={handleSearch}>
          <Box sx={style.form}>
              <Grid container spacing={2}>

                <Grid item xs={12} md={3} lg={2} >
                  <FormControl fullWidth>
                      <Typography style={{marginBottom: 10}} sx={style.label}>
                        Employer Name
                      </Typography>
                      <Autocomplete
                        id="combo-box-demo"
                        freeSolo
                        disableClearable
                        value={valueCompany}
                        onChange={handleSelectEmployer}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                        name='nameEmployer'
                        options={listCompanies.map((option) => option.name)}
                        sx={{ width: '100%'}}
                        renderInput={(params) => <TextField
                            {...params}
                            label=""
                            size='small'
                            onChange={(e) => handleChangeEmployer(e.target.value)}
                            InputProps={{
                              ...params.InputProps,
                              type: 'search',
                            }}
                          />
                        }
                      />
                  </FormControl>
                </Grid>

                {currentTab === 1 ?
                  <Grid item xs={12} md={3} lg={2} >
                    <FormControl fullWidth>
                      <Typography sx={style.label} style={{marginBottom: 10}}>
                        Employee Name
                      </Typography>
                      <TextField
                        id="nameEmployee"
                        variant="outlined"
                        name='nameEmployee'
                        size="small"
                        sx={{height: '40px'}}
                        value={employeeName}
                        onChange={(e) => setEmployeeName(e.target.value)}
                      />
                    </FormControl>
                  </Grid>
                  : null
                }

                <Grid item xs={12} md={2} lg={1} >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '20px',
                            alignItems: 'end',
                            justifyContent: 'center',
                            height: '100%',
                        }}
                    >
                        <Tooltip title="Clear filter">
                            <IconButton
                                onClick={handleClearFilters}
                                sx={{width: '40px', height: '40px'}}
                            >
                                <ClearAllIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Search">
                            <IconButton
                                type='submit'
                                sx={{width: '40px', height: '40px'}}
                            >
                                <SearchRoundedIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Grid>
              </Grid>
          </Box>
        </form>
    </Grid>
  )
}

export default FilterCompany
